import { Order } from "src/shared/services/interfacev2";
import api from "../../../../../../features/auth/axiosConfig";
import { API_URLS } from "../../../../../../shared/components/Url";
import { PaymentData } from "../../types/order";
import { formatDate, formatTime } from "../utils/orderUtils";
import { getLedgerByCustomerIdApi } from "src/business-types/laundry/modules/orders/order-display/api";

export const processPaymentRequest = async (
  orderid: string,
  order: Order,
  paymentData: PaymentData
) => {

  const customerId = order?.orders?.[0]?.customerId;

  const ledgerRes = await getLedgerByCustomerIdApi(customerId);

  const currentOutstanding =
    ledgerRes?.data?.ledger?.totalOutstandingBalance || 0;

  const previousReceived = (order?.paymentHistory || []).reduce(
    (sum, p) => sum + Number(p.receivedAmount || 0),
    0
  );

  const newReceived = Number(paymentData.ReceivedAmount || 0);

  const totalReceived = previousReceived + newReceived;

  const finalAmount = Number(order?.orders?.[0]?.finalAmount || 0);

  const discount = Number(paymentData.discount || 0);

  const remaining = finalAmount - totalReceived - discount;

  const safeRemaining = remaining > 0 ? remaining : 0;

  // const newOutstanding = currentOutstanding + safeRemaining;

  const now = new Date();

  await api.patch(`${API_URLS.ORDER}/${orderid}`, {
    customerId,
    remainingAmount: safeRemaining.toFixed(2),
    finalAmount,
    paymentHistory: [
      {
        paymentMethod: order?.paymentHistory?.[0]?.paymentMethod,
        receivedAmount: paymentData.ReceivedAmount,
      },
    ],
    payments: {
      paymentMethod: order?.paymentHistory?.[0]?.paymentMethod,
      receivedAmount: paymentData.ReceivedAmount,
    },
    outstandingBalance: currentOutstanding,
    newOrderAmount: "0",
    date: formatDate(now),
    time: formatTime(now),
    // deliveryDate: formatDate(now),
    // deliveryTime: formatTime(now),
    orderStatus: "Delivered",
    orderDate: formatDate(now),
    orderTime: formatTime(now),
  });

  return remaining;
};
